import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Form, FormGroup, Label, Row, Table } from 'reactstrap';
import { Btn, H3, Breadcrumbs } from "../../../AbstractElements";
import { useForm, Controller } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import { AddSub, Category, InvoiceDate, StbModem, Customer, ChooseSub, Recurring, PlanDate, Subscription, Save, Package, Addon, Notes, NewPayment, BinAccount, Amount, PaymentMethod, Reference, Attachments, Description, Payments } from "../../../Constant";
import { getCustomers, getPackage, getAddon, addCustomerSubscription, getCategoryRole, getCustomersRole, addCustomerSubscriptionRole, selectCustStb, getcategoryincome, selectCustStbRole, getPackageRole, getAddonRole, viewPayment, viewPaymentRole } from "../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken, postClientUrlWithToken } from "../../../Utils/restUtils";
import { toast } from 'react-toastify';
import Typeahead from "../../../CommonElements/TypeAhead";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import DatePicker from 'react-datepicker';
import moment from "moment";
import Transparentspinner from "../../Common/Loader/Transparentspinner";
import SubscribedTable from "./SubscribedTable";
import CustomerDropdown from "../../Common/CustomerField/CustomerDropdown";

const schema = yup.object().shape({
    stb: yup.mixed().required().label('STB/Modem'),
    customer: yup.mixed().required().label('Customer'),
    category: yup.mixed().required().label('Category'),
    recurring: yup.mixed().required().label('Recurring'),
})

const SubscriptionForm = () => {
    const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });
    const authState = useSelector((state) => state.auth);
    const currency = authState.currency;
    const [spinnerTrans, setspinnerTrans] = useState(false)
    const [discountError, setDiscountError] = useState(false);
    const [customer, setCustomer] = useState([]);
    const [category, setCategory] = useState([]);
    const [categoryOption, setCategoryOption] = useState([]);
    const [stbOption, setStbOption] = useState([]);
    const [packages, setPackage] = useState([]);
    const [packageOption, setPackageOption] = useState([]);
    const [selectedCust, setSelectedCust] = useState({});
    const [form, setForm] = useState([]);
    const [addons, setAddons] = useState([]);
    const [addonsOptions, setaddonsOptions] = useState([]);
    const [totalunitcost, settotalunitcost] = useState(0)
    const [totalDiscount, settotalDiscount] = useState(0)
    const [totalTaxamount, settotalTaxamount] = useState(0);
    const [grandTotal, setgrandTotal] = useState(0)
    const [disableOptions, setdisableOptions] = useState([])
    const [disableRecurring, setdisableRecurring] = useState(null)
    const [selectedstbId, setSelectedstbId] = useState(null);
    const navigate = useNavigate();
    const [startDate, setstartDate] = useState(new Date());
    const [planStart, setplanStart] = useState(new Date());
    const [payment, setPayment] = useState([]);
    const [paymentOption, setPaymentOption] = useState([]);
    const [logo, setLogo] = useState('');

    const recurringOptions = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];
    const recurringOptionssecound = [
        { value: 'no', label: 'No' },
    ];

    useEffect(() => {
        const newGrandTotal = form.reduce((acc, curr) => acc + curr.total, 0);
        const newUnitCost = form.reduce((acc, curr) => acc + curr.unitcost, 0);
        const newDiscount = form.reduce((acc, curr) => acc + curr.discount, 0);
        const newTaxAmount = form.reduce((acc, curr) => acc + curr.tax_amount, 0);
        settotalunitcost(parseFloat(newUnitCost).toFixed(authState.decimal));
        settotalDiscount(isNaN(newDiscount) ? 0 : parseFloat(newDiscount).toFixed(authState.decimal));
        settotalTaxamount(isNaN(newTaxAmount) ? 0 : parseFloat(newTaxAmount).toFixed(authState.decimal));
        setgrandTotal(isNaN(newGrandTotal) ? 0 : parseFloat(newGrandTotal).toFixed(authState.decimal));
    }, [form]);

    useEffect(() => {
        categoryData();
        customerData();
        packageData();
        paymentData();
    }, [selectedCust]);


    useEffect(() => {
        setPackageOption(packages.map((data) => ({
            value: data.id,
            label: `${data.name} - ${currency} ${data.price}`, // For filtering
            displayLabel: <div className="d-flex justify-content-between">
                <div>{data.name}</div>
                <div>{currency} {data.price}</div>
            </div>, // For rendering
            price: data.price,
            name: data.name,
            tax: data.tax_rates.map((t) => (t.name + '-' + t.tax_percentage + '%')),
            type: 'master',
            percentage: data.tax_rates.map((items) => items.tax_percentage),
        })));
        setCategoryOption(category.map((data) => ({ value: data.id, label: data.name })));
    }, [customer, category, packages]);

    useEffect(() => {
        setaddonsOptions(
            addons.map((data) => ({
                value: data.id,
                label: `${data.title} - ${currency} ${data.price}`, // For filtering
                displayLabel: <div className="d-flex justify-content-between">
                    <div>{data.title}</div>
                    <div>{currency} {data.price}</div>
                </div>, // For rendering
                price: data.price,
                tax: data.tax_rates.map((tax) => (tax.name + '-' + tax.tax_percentage + '%')),
                name: data.title,
                type: 'addon',
                percentage: data.tax_rates.map((items) => items.tax_percentage),
            }))
        )
    }, [addons]);

    useEffect(() => {
        setPaymentOption(
            payment.map((data) => ({
                value: data.id,
                label: data.name,
            }))
        );
    }, [payment]);

    const handleChangeInvoicedate = date => {
        setstartDate(date);
        setplanStart(date);
    };

    const handleChangePlanedate = (date) => {
        const prevMonthDate = moment().subtract(1, 'month').date('DD');
        const selectPastMonth = moment(date).isBefore(prevMonthDate);
        setplanStart(date);
        const recurringValue = selectPastMonth ? recurringOptions[1] : "";
        const disableValue = selectPastMonth ? 1 : 0;
        setValue("recurring", recurringValue);
        setdisableRecurring(disableValue);
    };

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const selectCustomerStb = async (e) => {
        setspinnerTrans(true)
        const selectedStbcust = e.value;
        let stb_api = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? selectCustStb + `?customer_id=${selectedStbcust}` : selectCustStbRole + `?customer_id=${selectedStbcust}`);
        if (stb_api.status === true) {
            const single_stb = stb_api.data.stb;
            setStbOption(
                single_stb.map((item) => ({
                    value: item.stb_no,
                    label: item.stb_no + '(' + item.connection_type + ')',
                    id: item.id,
                    connection: item.connection_type,
                }))
            );
            setspinnerTrans(false)

        } else {
            handleApiError(data.status);
        }
    }

    const categoryData = async () => {
        setspinnerTrans(true)
        let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getcategoryincome : getCategoryRole);
        if (data.status === true) {
            setCategory(data.data);
        } else {
            handleApiError(data.status);
        }
        setspinnerTrans(false)
    };

    const packageData = async (connectiontType) => {
        if (connectiontType) {
            setspinnerTrans(true)
            let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getPackage + `?connection_type=${connectiontType}` : getPackageRole + `?connection_type=${connectiontType}`);
            if (data.status === true) {
                setPackage(data.data);
            } else {
                handleApiError(data.status);
            }
            setspinnerTrans(false)
        }
    };

    const customerData = async () => {
        setspinnerTrans(true)
        let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getCustomers : getCustomersRole);
        if (data.status === true) {
            setCustomer(data.data);
        } else {
            handleApiError(data.status);
        }
        setspinnerTrans(false)
    };

    const paymentData = async () => {
        let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewPayment : viewPaymentRole);

        if (data.status === true) {
            setPayment(data.data);
        }
        else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);

        }
    };

    const addon = async (connection) => {
        setspinnerTrans(true)
        let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getAddon + `?connection_type=${connection}` : getAddonRole + `?connection_type=${connection}`);
        if (data.status === true) {
            setAddons(data.data);
        } else {
            handleApiError(data.status);
        }
        setspinnerTrans(false)
    }


    const resetCustomer = () => {
        setValue("recurring", '')
        setValue("stb", '')
        setValue("package", '')
        setValue("addon", '')
        setForm([])
    }
    const resetStb = () => {
        setValue("recurring", '')
        setValue("package", '')
        setValue("addon", '')
        setForm([])
    }

    const resetPackage = () => {
        setValue("addon", '')
    }

    const handleLogoChange = (event) => {
        const selectedFile = event.target.files[0];
        setLogo(selectedFile);
    }


    const handleProductSelect = (product) => {
        const mapPercent = product.percentage.reduce((acc, curr) => acc + curr, 0);
        const productDisc = product.price - (product.discount ?? 0);
        const priceWithTax = (mapPercent / 100) * productDisc;
        const unitCost = parseFloat(product.price).toFixed(authState.decimal);
        const newProduct = {
            ...product,
            type: product.type, discount_type: 'cash', package_id: product.value, unitcost: product.price, name: product.name,
            quantity: 1, price: unitCost, discount: 0, tax: product.tax, tax_amount: priceWithTax, total: product.price + priceWithTax
        };
        if (product.type === 'addon') {
            setForm([...form, newProduct]);
        } else {
            const existingIndex = form.findIndex(item => item.id === product.id);
            setForm(existingIndex !== -1 ? [newProduct] : [...form, newProduct]);
        }
    };

    const handleAddonOption = (value) => {
        setdisableOptions([...disableOptions, value]);
    }

    const handletotalamount = (index, value) => {
        setForm((prevForm) => {
            const updatedForm = [...prevForm];
            const currentRow = { ...updatedForm[index] };
            currentRow.discount = isNaN(value) ? 0 : parseFloat(value);
            const productPriceWithDiscount = currentRow.price - currentRow.discount;
            const taxAmount = (currentRow.percentage.reduce((acc, curr) => acc + curr, 0) / 100) * productPriceWithDiscount;
            currentRow.tax_amount = taxAmount;
            currentRow.total = isNaN(productPriceWithDiscount + taxAmount) ? productPriceWithDiscount : productPriceWithDiscount + taxAmount;
            updatedForm[index] = currentRow;
            setDiscountError(value >= currentRow.total);
            return updatedForm;
        });
    };

    const handleRemove = (index, value) => {
        if (form[index].type === 'master') {
            setValue("package", '');
            setValue("addon", '');
            setForm([]);
            setdisableOptions([]);
        } else {
            const updatedForm = form.filter((item, idx) => idx !== index);
            setForm(updatedForm);
            const addonId = value.value;
            setdisableOptions((disableOptions) => [...disableOptions.filter(num => num !== addonId), addonId]);
        }
    };

    const onCustomerChange = (value) => {
        setSelectedCust(value);          // Set the selected customer
        selectCustomerStb(value);        // Call the function to select STB
        resetCustomer();                 // Reset customer-specific fields
        setSelectedstbId(null);          // Reset STB ID
    };

    const onSubmit = async (data) => {
        setspinnerTrans(true)
        const invoice_Date = moment(startDate).format("DD-MM-YYYY");
        const plane_Date = moment(planStart).format("DD-MM-YYYY");
        const postRequest = {
            customer_id: data.customer.value,
            package_id: data.package.value,
            stb_no: data.stb.value,
            recurring: data.recurring.value,
            add_on: data.addon,
            comments: data.notes,
            category_id: data.category.value,
            start_date: plane_Date,
            invoice_date: invoice_Date,
            items: form,
        }
        const addCustomerSubscriptionResponse = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? addCustomerSubscription : addCustomerSubscriptionRole, postRequest);
        const id = addCustomerSubscriptionResponse?.data?.data;
        if (addCustomerSubscriptionResponse.status === 200) {
            if (addCustomerSubscriptionResponse.data.status === true) {
                if (id) {
                    const cust_id = data.customer.value;
                    navigate(`${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${id}&customer_id=${cust_id}`);
                }
                toast.success(addCustomerSubscriptionResponse.data.message);
            } else {
                toast.error(addCustomerSubscriptionResponse.data.message);
                setspinnerTrans(false)
            }
        } else {
            handleApiError(addCustomerSubscriptionResponse.status);
        }
        setspinnerTrans(false)
    };
    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            <Breadcrumbs mainTitle={Payments} parent="Billing" title={Payments} />
            <Card>
                <CardHeader className="pb-0">
                    <H3>{NewPayment}</H3>
                </CardHeader>
                <CardBody>
                    <Form className="needs-validation" noValidate onSubmit={handleSubmit(onSubmit)}>
                        <Row className="g-3 pt-3">
                            <CustomerDropdown
                                control={control}
                                errors={errors}
                                onCustomerChange={onCustomerChange}
                            />
                            <Col md="6">
                                <Label className="form-label" >{BinAccount} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="stb"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            placeholder="Select..."
                                            options={stbOption}
                                            onChange={(value) => {
                                                field.onChange(value);
                                                const connection = value.connection;
                                                packageData(connection)
                                                addon(connection)
                                                setSelectedstbId(value.id);
                                                resetStb()
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.stb?.message}</p>
                            </Col>
                        </Row>
                        {selectedstbId != null && (
                            <SubscribedTable
                                data={selectedstbId}
                                setSpinner={setspinnerTrans}
                            />
                        )}
                        <Row className="g-3 pt-3">
                            <Col md="6">
                                <FormGroup className="mb-3">
                                    <Label className="form-label" for="invoice_date">Date <span className="requireStar">*</span></Label>
                                    <Col xl='12' md="12" sm='12'>
                                        <DatePicker
                                            id="invoice_date"
                                            style={{ padding: '12px 100px' }}
                                            className="form-control "
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="dd/mm/yyyy"
                                            selected={startDate}
                                            onChange={handleChangeInvoicedate}
                                            required
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" for="name">{Amount} <span className="requireStar">*</span></Label>
                                <input
                                    className="form-control"
                                    id="name"
                                    type="number"
                                    {...register("amount", { required: true })}
                                />
                                <p className="text-danger">{errors.amount?.message}</p>
                            </Col>
                        </Row>
                        <Row className="">
                            <Col md="6">
                                <Label className="form-label" >{Category} <span className="requireStar">*</span></Label>
                                <Controller
                                    name="category"
                                    control={control}
                                    render={({ field }) => (
                                        <Typeahead
                                            options={categoryOption}
                                            onChange={(value) => {
                                                field.onChange(value);
                                            }}
                                            value={field.value}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.category?.message}</p>
                            </Col>
                            <Col md="6">
                                <Label className="form-label" >
                                    {PaymentMethod} <span className="requireStar">*</span>
                                </Label>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Controller
                                        name="payment_method"
                                        control={control}
                                        render={({ field }) => (
                                            <Typeahead
                                                placeholder="select..."
                                                options={paymentOption}
                                                onChange={(value) => {
                                                    field.onChange(value);
                                                }}
                                                value={field.value}
                                            />
                                        )}
                                    />

                                </div>
                                <p className="text-danger">{errors.payment_method?.message}</p>
                            </Col>
                        </Row>
                        <Row className="g-3 pt-3">

                            <Col>
                                <Label className="form-label pt-1">{Reference}</Label>
                                <Controller
                                    name="address"
                                    control={control}
                                    render={({ field }) => (
                                        <input className="form-control" {...field} rows="4" />
                                    )}
                                />
                            </Col>

                            <Col md="6">
                                <Label className="form-label">{Attachments}</Label>
                                <Controller
                                    name="logo"
                                    control={control}
                                    render={({ field }) => (
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <Col md="8">
                                                <input
                                                    {...register("logo")}
                                                    className="form-control fileInputStyle"
                                                    type="file"
                                                    // onChange={handleLogoChange}
                                                    accept=".png, .jpg, .jpeg"
                                                />
                                            </Col>
                                            <Col md='4'>
                                                <span className="imagestyle">
                                                    {logo && <img src={URL.createObjectURL(logo)} alt="logo" width="40px" height="40px" />}
                                                </span>
                                            </Col>
                                        </div>
                                    )}
                                />
                                <span className="text-danger">{errors.logo && "logo is required"}</span>
                            </Col>


                        </Row>


                        <Row>
                            <Col>
                                <Label className="form-label pt-3">{Description}</Label>
                                <Controller
                                    name="notes"
                                    control={control}
                                    render={({ field }) => (
                                        <textarea
                                            className="form-control"
                                            {...field}
                                            rows="3"
                                            maxLength={250}
                                            {...register('notes', { required: true })}
                                        />
                                    )}
                                />
                                <p className="text-danger">{errors.notes?.message}</p>
                            </Col>
                        </Row>
                        <FormGroup>
                        </FormGroup>
                        <div className="d-flex justify-content-center mt-3 gap-2">
                            <Btn attrBtn={{ color: "primary" }} type="submit">
                                {Save}
                            </Btn>
                            <Link to="/billing/subscription" className="btn btn-light" type="button">
                                Cancel
                            </Link>
                        </div>
                    </Form>

                </CardBody>
            </Card>
        </Fragment>
    )
}
export default SubscriptionForm;